import React from "react";
import { useNavigate } from "react-router-dom";
import { FaShareAlt, FaRegCalendarAlt, FaDollarSign } from "react-icons/fa";
import classes from "./GrantlarVaLoyihalar.module.css";
import {
  getLabels,
  normLang,
  pick,
  formatDate,
  daysLeft,
  flagUrl,
  imgUrl,
  shareLink,
} from "./grantUtils";

const GrantCard = ({ item, lang, onToast }) => {
  const navigate = useNavigate();
  const L = getLabels(lang);

  const title = pick(item, "title", lang);
  const country = pick(item, "country", lang);
  const funding = pick(item, "funding", lang);
  const flag = flagUrl(item.country_code);
  const left = daysLeft(item.deadline);
  const expired = left !== null && left < 0;

  const detailPath = `/grantlar/${item.id}`;

  const handleShare = async (e) => {
    e.stopPropagation();
    const url = `${window.location.origin}/${normLang(lang)}${detailPath}`;
    const result = await shareLink(url, title);
    if (result === "copied" && onToast) onToast(L.copied);
  };

  let deadlineNote = null;
  if (left === null) deadlineNote = null;
  else if (left < 0) deadlineNote = L.expired;
  else if (left === 0) deadlineNote = L.lastDay;
  else deadlineNote = L.daysLeft(left);

  return (
    <div
      className={`${classes.card} ${expired ? classes.cardExpired : ""}`}
      onClick={() => navigate(detailPath)}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && navigate(detailPath)}
    >
      <div className={classes.imageWrap}>
        <img src={imgUrl(item.image)} alt={title} className={classes.image} />

        {(country || flag) && (
          <span className={classes.country}>
            {flag && (
              <img
                src={flag}
                alt=""
                className={classes.flag}
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            )}
            {country}
          </span>
        )}

        <button
          type="button"
          className={classes.share}
          onClick={handleShare}
          title={L.share}
          aria-label={L.share}
        >
          <FaShareAlt />
        </button>

        {expired && <span className={classes.expiredBadge}>{L.expired}</span>}
      </div>

      <div className={classes.body}>
        <h3 className={classes.title}>{title}</h3>

        <div className={classes.meta}>
          <div>
            <div className={classes.metaLabel}>{L.funding}</div>
            <div className={classes.metaValue}>
              <FaDollarSign className={classes.metaIcon} />
              <span>{funding || "—"}</span>
            </div>
          </div>
          <div>
            <div className={classes.metaLabel}>{L.deadline}</div>
            <div className={`${classes.metaValue} ${item.deadline ? classes.metaValueDeadline : ""}`}>
              <FaRegCalendarAlt className={classes.metaIcon} />
              <span>{item.deadline ? formatDate(item.deadline, lang) : L.noDeadline}</span>
            </div>
            {deadlineNote && (
              <div
                className={`${classes.daysLeft} ${
                  left !== null && left >= 0 && left <= 7 ? classes.daysLeftUrgent : ""
                }`}
              >
                {deadlineNote}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrantCard;
